import React, { useEffect, useState } from "react";
import classnames from "classnames";
import _ from "lodash";
import moment from "moment";
import DateTimePicker from "../../../components/DateTimePicker";
import TimePicker from "../../../components/TimePicker";
import RadioItem from "../../../components/RadioItem";

const FeedPostingEdit = ({
  selectedDate,
  onChangeTime,
  isVisible,
  feed,
  trackModification,
}) => {
  const [scheduling, setScheduling] = useState({});
  const [toMembers, setToMembers] = useState(true);
  const [toReferrals, setToReferrals] = useState(true);
  const [textComments, setTextComments] = useState(true);
  const [mediaComments, setMediaComments] = useState(true);

  const [modification, setModification] = useState({});

  useEffect(() => {
    console.log("selectedDate", selectedDate);
    console.log("feed", feed);
    if (feed) {
      setScheduling({
        postNow: feed.postNow,
        scheduledDate: feed.scheduledDate,
      });
      setToMembers(feed.toMembers === undefined || feed.toMembers);
      setToReferrals(feed.toReferrals === undefined || feed.toReferrals);
      setTextComments(feed.textComments === undefined || feed.textComments);
      setMediaComments(feed.mediaComments === undefined || feed.mediaComments);
      setModification({});
    }
  }, [feed]);
  useEffect(() => {
    console.log("modification", modification);
    if (trackModification) trackModification(modification);
  }, [modification]);

  useEffect(() => {
    onChangeTime(scheduling);
  }, [scheduling]);
  const handleSchedule = (value) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.scheduledDate = moment(value).valueOf();
    setScheduling(newScheduling);
    // modification tracking..
    let newModification = {
      ...modification,
      scheduledDate: moment(value).valueOf(),
    };
    setModification(newModification);
  };
  const handlePostNowChanged = (value) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.postNow = value;
    setScheduling(newScheduling);
    // modification tracking..
    let newModification = { ...modification, postNow: value };
    setModification(newModification);
  };
  const handleChangeTime = (obj) => {
    const { hh, mm, of } = obj;
    let hours = hh;
    let newMoment = moment(selectedDate);
    if (of === "pm" && hh !== 12) hours = hh + 12;
    newMoment.set("hour", hours);
    newMoment.set("minute", mm);
    const newScheduling = _.cloneDeep(scheduling);
    let newModification = { ...modification };
    if (newMoment.isBefore(moment())) {
      newScheduling.postNow = true;
      newModification.postNow = true;
    } else {
      newScheduling.postNow = false;
      newModification.postNow = false;
    }
    newScheduling.scheduledDate = moment(newMoment).valueOf();
    newModification.scheduledDate = moment(newMoment).valueOf();
    setScheduling(newScheduling);
    setModification(newModification);
  };
  const handleChangeMembersAccess = (value) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.toMembers = value;
    setScheduling(newScheduling);
    // modification tracking..
    let newModification = { ...modification, toMembers: value };
    setModification(newModification);
  };
  const handleChangeReferralsAccess = (value) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.toReferrals = value;
    setScheduling(newScheduling);
    // modification tracking..
    let newModification = { ...modification, toReferrals: value };
    setModification(newModification);
  };
  const handleTextComments = (value) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.textComments = value;
    if (!value) {
      newScheduling.mediaComments = false;
    }
    setScheduling(newScheduling);
    // modification tracking..
    let newModification = { ...modification, textComments: value };
    if (!value) {
      newModification.mediaComments = false;
    }
    setModification(newModification);
  };
  const handleMediaComments = (value) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.mediaComments = value;
    setScheduling(newScheduling);
    // modification tracking..
    let newModification = { ...modification, mediaComments: value };
    setModification(newModification);
  };

  return (
    <div className={`feed-schedule-container ${!isVisible ? "d-none" : ""}`}>
      <p className="feed-schedule-title">
        {!selectedDate && (
          <React.Fragment>
            <b>Post now</b> or{" "}
          </React.Fragment>
        )}
        <b>Schedule</b>
      </p>
      {!selectedDate && (
        <div className="feed-schdule-now-container">
          <div
            className={classnames("check-box", {
              checked: scheduling.postNow,
            })}
            onClick={() => handlePostNowChanged(true)}
            style={{
              marginLeft: "20px",
            }}
          ></div>
          <div
            className={classnames("check-box", {
              checked: !scheduling.postNow,
            })}
            onClick={() => handlePostNowChanged(false)}
            style={{
              marginLeft: "80px",
            }}
          ></div>
        </div>
      )}
      {!scheduling.postNow && !selectedDate && (
        <DateTimePicker
          onTimeChange={handleSchedule}
          time={scheduling.scheduledDate}
        />
      )}
      {selectedDate && (
        <React.Fragment>
          <p className="feed-schedule-time">{selectedDate.format("LLL")}</p>
          <TimePicker onChange={handleChangeTime} />
        </React.Fragment>
      )}
      <div className="user-access-categories">
        <p>Post to user access categories</p>
        <RadioItem
          menuName="Members"
          checked={toMembers}
          onYes={() => {
            setToMembers(true);
            handleChangeMembersAccess(true);
          }}
          onNo={() => {
            setToMembers(false);
            handleChangeMembersAccess(false);
          }}
        />
        <RadioItem
          menuName="Prospect"
          checked={toReferrals}
          onYes={() => {
            setToReferrals(true);
            handleChangeReferralsAccess(true);
          }}
          onNo={() => {
            setToReferrals(false);
            handleChangeReferralsAccess(false);
          }}
        />
        <RadioItem
          menuName="Text comments"
          checked={textComments}
          onYes={() => {
            setTextComments(true);
            handleTextComments(true);
          }}
          onNo={() => {
            setTextComments(false);
            setMediaComments(false);
            handleTextComments(false);
          }}
        />
        <RadioItem
          menuName="Media comments"
          checked={mediaComments}
          onYes={() => {
            if (textComments) {
              setMediaComments(true);
              handleMediaComments(true);
            }
          }}
          onNo={() => {
            setMediaComments(false);
            handleMediaComments(false);
          }}
        />
      </div>
    </div>
  );
};
export default FeedPostingEdit;



// WEBPACK FOOTER //
// ./src/screens/Feeds/components/FeedPostingEdit.js